import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m7 31h18a3 3 0 0 0 3-3v-17.171a3.21 3.21 0 0 0 -.879-2.122l-6.828-6.828a3.212 3.212 0 0 0 -2.121-.879h-11.172a3 3 0 0 0 -3 3v24a3 3 0 0 0 3 3zm17.586-22h-3.586a1 1 0 0 1 -1-1v-3.586zm-18.586-5a1 1 0 0 1 1-1h11v5a3 3 0 0 0 3 3h5v17a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1-1z" })
});
export default SvgFile;
